import { dropAllDatabases } from "@rocicorp/zero";

import { useAuthEvent } from "../auth-store";
import { type KvStore, useZero } from "../zero/zero-config";

interface ZeroEventHandlersProps {
  kvStore?: KvStore;
}

export function ZeroEventHandlers({ kvStore }: ZeroEventHandlersProps): null {
  const zero = useZero();

  useAuthEvent("user_changed", async () => {
    await dropAllDatabases({ kvStore });
  });

  useAuthEvent("signed_out", async () => {
    await zero.close();
    await dropAllDatabases({ kvStore });
  });

  useAuthEvent("token_refreshed", (newToken: string) => {
    zero.connection.connect({ auth: newToken });
  });

  return null;
}
